import styled from 'styled-components'
import { THEME } from '@src/theme'

export const StyledError = styled.p`
  color: ${THEME.color.cinnabar};
`
